module.exports = __webpack_public_path__ + "static/img/RAOK-1P_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAOK-1P_1.png
// module id = EX0z
// module chunks = 0